import "./StatMeter.css";

type TeamData = {
  score: number;
  color: string;
};

export function StatMeter({
  label,
  scoreLabel,
  isStandaloneStat,
  teamAData,
  teamBData,
}: {
  label: string;
  scoreLabel: string;
  teamAData: TeamData;
  teamBData: TeamData;
  isStandaloneStat: boolean; //isStandaloneStat: stats value/meter of team is not interdependent on other team
}) {
  const { score: teamAscore } = teamAData;
  const { score: teamBscore } = teamBData;

  const totalScore = Math.round(teamAscore + teamBscore);
  const teamAScoreRounded = Math.round(teamAscore);
  const teamBScoreRounded = isStandaloneStat
    ? Math.round(teamBscore)
    : totalScore - teamAScoreRounded;
  const team_a_percent = isStandaloneStat
    ? teamAScoreRounded
    : totalScore
    ? Math.ceil((teamAScoreRounded / totalScore) * 100)
    : 0;
  const team_b_percent = isStandaloneStat
    ? teamBScoreRounded
    : totalScore
    ? 100 - team_a_percent
    : 0;

  return (
    <div className="stat-meter-container">
      <div className="stat-meter-text">
        <span className="stat-score home">
          {teamAScoreRounded}
          {scoreLabel}
        </span>
        <span className="stat-label">{label}</span>
        <span className="stat-score away">
          {teamBScoreRounded}
          {scoreLabel}
        </span>
      </div>
      <div className="stat-meter-bar">
        <div className="bar">
          <div
            style={{
              width: `${team_a_percent}%`,
              backgroundColor: teamAData.color || undefined,
            }}
            className="home-team-fill-bar"
          />
        </div>
        <div className="bar">
          <div
            style={{
              width: `${team_b_percent}%`,
              backgroundColor: teamBData.color || undefined,
            }}
            className="away-team-fill-bar"
          />
        </div>
      </div>
    </div>
  );
}
